exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".IntervalEditor {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.IntervalEditor > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: stretch;\r\n\t    align-items: stretch;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n\t-ms-flex-pack: justify;\r\n\t    justify-content: space-between;\r\n}\r\n\r\n.IntervalEditor > div > #hyphen {\r\n\tline-height: 41px;\r\n\ttext-align: center;\r\n\twidth: 50px;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.IntervalEditor > div > *:not(#hyphen) {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-pack: center;\r\n\t    justify-content: center;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.IntervalEditor > div > .Input {\r\n\tpadding: 5px;\r\n\tmargin: 5px;\r\n\ttext-align: center;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/IntervalEditor/IntervalEditor.css
// module id = 691
// module chunks = 0